import { queryClient } from "@/queryClient"

export const deleteMerchantGroup = async (
  merchantGroupId: string
) => {
  await api.delete(`/merchant-groups/${merchantGroupId}`)

  queryClient.invalidateQueries({
    queryKey: [MERCHANT_GROUPS_QUERY_KEY],
  })
}
